// Pure helpers: stable client-side IDs for break rows + payload sanitisation.

export const genBreakUid = () =>
  `brk-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;

// Normalise operating_hours so every break row carries a stable `_uid`.
// Used when loading a location from the API into the form. Keeps React inputs
// from remounting when the user edits start/end/reason values (those are the
// very fields being typed and can't be used as keys).
export const withBreakUids = (operatingHours) => {
  if (!operatingHours) return operatingHours;
  const out = {};
  for (const day of Object.keys(operatingHours)) {
    const d = operatingHours[day] || {};
    out[day] = {
      ...d,
      breaks: (d.breaks || []).map((b) => (b._uid ? b : { ...b, _uid: genBreakUid() })),
    };
  }
  return out;
};

// Strip `_uid` from break rows before persisting. The backend Pydantic model
// rejects unknown fields.
export const stripBreakUids = (operatingHours) => {
  if (!operatingHours) return operatingHours;
  const out = {};
  for (const day of Object.keys(operatingHours)) {
    const d = operatingHours[day] || {};
    out[day] = {
      ...d,
      // eslint-disable-next-line no-unused-vars
      breaks: (d.breaks || []).map(({ _uid, ...rest }) => rest),
    };
  }
  return out;
};
